/**
 * Helper
 */
var helper = require('../../helper');


function* generator_header(date_start){
    var now = new Date();
    while(date_start < now){
        yield ("0" + (date_start.getMonth() + 1)).slice(-2)+'/'+date_start.getFullYear().toString().substr(-2);
        date_start.setMonth(date_start.getMonth() + 1);
    }
}

$(function() {
    var $datatable = $('#datatable-block-vip'),
        blockId = $datatable.data('block'),
        tab = $('#horizontal-table'),
        date_start = new Date(2015, 0, 1 ),
        gen = generator_header(date_start),
        columns = [
            {data: 'property_name', name: 'property_name', orderable: true, searchable: true},
            {data: 'date_taken_on', name: 'date_taken_on', orderable: false, searchable: false},
        ],
        $dt;

    for ( let header of gen){
        columns.push({data: header, name: header, orderable: false, searchable: false});
        $('<th>'+header+'</th>').appendTo(tab);
    }

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "scrollX": true,
        "ajax": {
            "url": helper.getOrigin() + "/api/vip/block/" + blockId,
            "method": 'POST',
        },
        "bAutoWidth" : false,
        "paging": false,
        "columns": columns
    });

    new $.fn.dataTable.FixedColumns($dt, {
        leftColumns: 2,
        heightMatch: 'auto'
    });
});
